"use client";

import posthog from "posthog-js";
import { pickAllowed, type BrowserEvent, type EventProps } from "@/lib/posthog/generated/events";

// Product events from the dashboard; unknown props are dropped and telemetry never throws.
export function track<E extends BrowserEvent>(event: E, props?: EventProps<E>): void {
  try {
    if (!posthog.__loaded) return;
    const allowed = pickAllowed(event, props);
    if (allowed) posthog.capture(event, allowed);
  } catch {
    // Telemetry must never turn into a user-facing error.
  }
}
